import React from "react";
import PropTypes from "prop-types";
import Contact from "./Contact";
import styled from "styled-components";

import { useState } from "react";

const ListContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const FullList = styled.div`
  width: 49%;
`;

const CustomerList = styled.div`
  width: 49%;
`;

const Search = styled.input`
  width: 100%;
  padding: 5px 10px;
  border: 1px solid lightgrey;
  margin: 20px 0;
`;

const CustomerTag = styled.div`
  text-transform: uppercase;
  font-weight: 900;
  color: var(--primary);
  padding: 10px 0px;
  opacity: 0.4;
  display: flex;
  align-items: center;
  font-size: 10px;
  div {
    width: 100%;
    border-top: 1px solid var(--primary);
    margin-left: 10px;
  }
`;

function ContactList({
  contacts,
  onContactSelection,
  onClickDelete,
  comments,
}) {
  const [searchFor, setSearchFor] = useState(null);
  const [viewAmount, setViewAmount] = useState(50);

  let contactVisible = [];
  let viewingContacts = [];

  const sortSearch = (array, key) => {
    const startingArray = array;
    if (key) {
      const firstNameArray = startingArray.filter((e) => {
        return (
          e.firstName.toLowerCase().lastIndexOf(key.toLowerCase(), 0) === 0 ||
          e.lastName.toLowerCase().lastIndexOf(key.toLowerCase(), 0) === 0 ||
          e.contactType.toLowerCase().lastIndexOf(key.toLowerCase(), 0) === 0
        );
      });
      contactVisible = firstNameArray;
    }
  };

  const sortDate = (array) => {
    const sorter = (a, b) => {
      return (
        new Date(a.createdTime).getTime() - new Date(b.createdTime).getTime()
      );
    };
    return array.sort(sorter).reverse();
  };

  const setView = (contacts, amount) => {
    return contacts.slice(0, amount);
  };

  const showMore = () => {
    setViewAmount(viewingContacts.length + 25);
  };

  const handleSearchFor = (event) => {
    setSearchFor(event.target.value);
    sortSearch(contacts, searchFor);
  };

  const showContacts = (contacts, amount) => {
    contactVisible = contacts;
    contactVisible = sortDate(contactVisible);
    sortSearch(contactVisible, searchFor);
    return setView(contactVisible, amount).sort(
      (a, b) => b.createdTime - a.createdTime
    );
  };

  const showCustomers = (arr) => {
    let customers = arr.filter((e) => e.contactType === "customer");
    return customers.sort((a, b) => b.createdTime - a.createdTime);
  };

  if (contacts.length) {
    return (
      <>
        <Search
          onChange={handleSearchFor}
          type="search"
          placeholder="Search Contacts"
        />

        <ListContainer>
          <CustomerList>
            <CustomerTag>
              Customers<div></div>
            </CustomerTag>
            {showCustomers(contacts).map((contact) => (
              <Contact
                whenContactClicked={onContactSelection}
                contact={contact}
                id={contact.id}
                key={contact.id}
                onClickDelete={onClickDelete}
                customer={true}
                comments={comments.filter((c) => c.contactID === contact.id)}
              />
            ))}
          </CustomerList>
          <FullList>
            {showContacts(contacts, viewAmount).map((contact) => (
              <Contact
                whenContactClicked={onContactSelection}
                contact={contact}
                id={contact.id}
                key={contact.id}
                onClickDelete={onClickDelete}
                customer={false}
                comments={comments.filter((c) => c.contactID === contact.id)}
              />
            ))}
          </FullList>
        </ListContainer>
        <br />
        <p
          className="show-more mb-5"
          onClick={() => showMore(viewingContacts, contactVisible)}
        >
          show more
        </p>
      </>
    );
  } else {
    return (
      <>
        <br />
        <div className="row">
          <div className="col-12">
            <input
              onChange={handleSearchFor}
              type="search"
              placeholder="Search Contacts"
              className="form-control"
            />
          </div>
        </div>
        <div className="lds-ellipsis mx-auto my-5">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <br />
      </>
    );
  }
}

ContactList.propTypes = {
  onContactSelection: PropTypes.func,
};

export default ContactList;
